import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  container: {
    display: 'block',
    width: '100%',
    float: 'left',
    color: '#818a91',
    fontSize: '14px',
    marginBottom: '20px',
  },
  title: {
    margin: '0',
  },
  content: {
    display: 'block',
    width: '100%',
    float: 'left',
  },
};

const PictureNote = ({ width, height, classes }) => {
  return (
    <div className={classes.container}>
      <h5 className={classes.title}>Please Note: </h5>
      <small className={classes.content}>1. Image type has to be JPG/JPEG/PNG. </small>
      <small className={classes.content}>
        2. Image resolution should be {height}
        px x {width}
        px.{' '}
      </small>
      <small className={classes.content}>3. Image max size 500 Kb. Smaller size means faster loading.</small>
    </div>
  );
};

export default withStyles(styles)(PictureNote);



// WEBPACK FOOTER //
// ./src/components/PictureNote/index.js